import { ValidConnector } from '@/types/Connectors';

export const QUERY_SEPARATOR_SIGN = '_';
export const QUERY_EQUALITY_SIGN = ':';
export const ITEMS_PER_PAGE = 25;
export const keywordSelectLanguages = ['de', 'en'];

export const FACEBOOK_CONNECTION_STEPS = [
  'choose how to connect',
  'Choose Advertising accounts',
] as const;

export const GOOGLE_ANALYTICS_CONNECTION_STEPS = [
  'choose how to connect',
  'Choose reports',
];

export const GOOGLE_ANALYTICS_MANUAL_CONNECTION_STEPS = [
  'choose how to connect',
  'Add Marchemy to your BigQuery dataset',
] as const;

export const GOOGLE_ANALYTICS_INFO_STEPS = [
  'choose how to connect',
  'configure your connection',
];

export const DATA_FOR_SEO_CONNECTION_STEPS = [
  'Choose your location and timezone',
  'Add Tags',
  'Add keywords',
] as const;

export const SHOPIFY_CONNECTION_STEPS = ['Provide your store URL'];

type DashboardId = 'general' | 'organicsearch';

export const NAV_ROUTES = {
  root: '/',
  login: '/login',
  workspaceSettings: '/workspace-settings',
  organizationSettings: '/organization-settings',
  verifyEmail: '/verify-email',
  connectors: '/connectors',
  connectorsList: '/connectors/list',
  subscriptions: '/subscriptions',
  handleInvitation: '/handleInvitation',
  dashboards: '/dashboards',
  missingPermissions: '/missing-permissions',
  wrongSubscriptionTier: '/wrong-subscription-tier',
  dashboard: (dashboardId: DashboardId) => `/dashboards/${dashboardId}`,
  connectorInfo: (connectorId: ValidConnector) => `/connectors/info/${connectorId}`,
  connectorEdit: (connectorId: ValidConnector) => `/connectors/edit/${connectorId}`,
  connectorError: (connectorId: ValidConnector) => `/connectors/error/${connectorId}`,
} as const;

export const firebaseFunctionErrorsMapping: Record<string, string> = {
  'Organization has reached the maximum number of workspaces':
    'Your organization has reached the maximum number of workspaces. Please upgrade your plan to create more workspaces.',
};

export const connectorsWithPngIcons = ['dataforseo', 'linkedin-ads'];

export const ERROR_MESSAGES: Record<string, string> = {
  CANNOT_SEND_EMAIL: 'Failed to send invitation email. Try resending later!',
};
